import { Outlet } from 'react-router-dom';

function Admin() {
    return <Outlet />;
}

export default Admin;
